const setImportSheetModalStateAction = ({ commit }, payload) => {
  commit('setImportSheetModalState', payload)
}

const setAIRequestLimitModalStateAction = ({ commit }, payload) => {
  commit('setAIRequestLimitModalState', payload)
}

const setShowModalTemplateLibraryAction = ({ commit }, payload) => {
  if (payload && typeof payload === 'object') {
    const visible = !!payload.visible
    commit('setShowModalTemplateLibraryState', visible)
    if (Object.prototype.hasOwnProperty.call(payload, 'initialCategoryId')) {
      commit('setInitialTemplateLibraryCategoryIdState', payload.initialCategoryId)
    }
    if (Object.prototype.hasOwnProperty.call(payload, 'deepLinkSource')) {
      commit('setTemplateLibraryDeepLinkSourceState', payload.deepLinkSource)
    }
    // Closing the modal must wipe leftover deep-link state — otherwise a
    // subsequent open (e.g. KickstartScreen "Templates" button) would replay
    // a stale category and re-fire the deep-link Mixpanel event.
    if (!visible) {
      commit('setInitialTemplateLibraryCategoryIdState', null)
      commit('setTemplateLibraryDeepLinkSourceState', null)
    }
    return
  }
  commit('setShowModalTemplateLibraryState', payload)
  if (!payload) {
    commit('setInitialTemplateLibraryCategoryIdState', null)
    commit('setTemplateLibraryDeepLinkSourceState', null)
  }
}

export default {
  setImportSheetModalStateAction,
  setAIRequestLimitModalStateAction,
  setShowModalTemplateLibraryAction,
}
